var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_572_2829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3853 20C15.9087 20 20.3853 15.5234 20.3853 10C20.3853 4.47656 15.9087 0 10.3853 0C4.86182 0 0.385254 4.47656 0.385254 10C0.385254 15.5234 4.86182 20 10.3853 20ZM14.7993 8.16406L9.79932 13.1641C9.43213 13.5312 8.83838 13.5312 8.4751 13.1641L5.9751 10.6641C5.60791 10.2969 5.60791 9.70312 5.9751 9.33984C6.34229 8.97656 6.93604 8.97266 7.29932 9.33984L9.13525 11.1758L13.4712 6.83594C13.8384 6.46875 14.4321 6.46875 14.7954 6.83594C15.1587 7.20312 15.1626 7.79687 14.7954 8.16016L14.7993 8.16406Z",
    fill: "#078177"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_2829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.385254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckSolid);
export default __webpack_public_path__ + "static/media/circle-check-solid.0ff6c99c8066f5383dc826451e73580c.svg";
export { ForwardRef as ReactComponent };